import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { BoardManager } from "./BoardManger";

export class InfoLayer extends Phaser.GameObjects.Container {

    private howToPlayContainer: Phaser.GameObjects.Container;
    private scoreSystemContaiener: Phaser.GameObjects.Container;
    private howToPlayTab: Phaser.GameObjects.Image;
    private scoreSystemTab: Phaser.GameObjects.Image;
    private closeLayerButton: Button;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x2c241f, .60);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        if (GameConstants.SHOW_SCORE) {

            this.scoreSystemContaiener = new Phaser.GameObjects.Container(this.scene);
            this.scoreSystemContaiener.x = GameConstants.GAME_WIDTH / 2;
            this.scoreSystemContaiener.y = 50;
            this.scoreSystemContaiener.scaleX = GameVars.scaleX;
            this.add(this.scoreSystemContaiener);

            this.scoreSystemTab = new Phaser.GameObjects.Image(this.scene, 140, -45, "texture_atlas_1", "tab_score_system_inactive");
            this.scoreSystemTab.setOrigin(.5, 0);
            this.scoreSystemTab.setInteractive({useHandCursor: true});
            this.scoreSystemTab.on("pointerdown", this.onClickScore, this);
            this.scoreSystemContaiener.add(this.scoreSystemTab);

            const scoreSystem = new Phaser.GameObjects.Image(this.scene, 0, 0, "score_system");
            scoreSystem.setOrigin(.5, 0);
            this.scoreSystemContaiener.add(scoreSystem);
        }

        this.howToPlayContainer = new Phaser.GameObjects.Container(this.scene);
        this.howToPlayContainer.x = GameConstants.GAME_WIDTH / 2;
        this.howToPlayContainer.y = 50;
        this.howToPlayContainer.scaleX = GameVars.scaleX;
        this.add(this.howToPlayContainer);

        if (GameConstants.SHOW_SCORE) {
            
            this.howToPlayTab = new Phaser.GameObjects.Image(this.scene, -140, -45, "texture_atlas_1", "tab_how_to_play");
            this.howToPlayTab.setOrigin(.5, 0);
            this.howToPlayTab.setInteractive({useHandCursor: true});
            this.howToPlayTab.on("pointerdown", this.onClickHowToPlay, this);
            this.howToPlayContainer.add(this.howToPlayTab);
        }

        const howToPlay = new Phaser.GameObjects.Image(this.scene, 0, 0, "how_to_play");
        howToPlay.setOrigin(.5, 0);
        this.howToPlayContainer.add(howToPlay);

        const label1 = new Phaser.GameObjects.Text(this.scene, 0, 42, gameText.CLEAR_TILES_BY_MATCHING_PAIRS[lan], {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#A17A65"});
        label1.setOrigin(.5);
        this.howToPlayContainer.add(label1);

        const label2 = new Phaser.GameObjects.Text(this.scene, 0, 272, gameText.MATCH_PAIRS_OF_TILES_THAT[lan], {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#A17A65"});
        label2.setOrigin(.5);
        this.howToPlayContainer.add(label2);

        const label3 = new Phaser.GameObjects.Text(this.scene, 0, 615, gameText.TILES_OF_SPEC_SETS_MATCH_FREELY[lan], {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#A17A65"});
        label3.setOrigin(.5);
        this.howToPlayContainer.add(label3);

        const label4 = new Phaser.GameObjects.Text(this.scene, -345, 540, gameText.SAME_DESIGN[lan], {fontFamily: "OpenSans-CondLight", fontSize: "23px", color: "#f9f3cc"});
        label4.setOrigin(.5);
        this.howToPlayContainer.add(label4);

        const label5 = new Phaser.GameObjects.Text(this.scene, 0, label4.y, gameText.NOT_COVERED[lan], {fontFamily: "OpenSans-CondLight", fontSize: "23px", color: "#f9f3cc"});
        label5.setOrigin(.5);
        this.howToPlayContainer.add(label5);

        const label6 = new Phaser.GameObjects.Text(this.scene, -label4.x, label4.y, gameText.ONE_FREE_SIDE[lan], {fontFamily: "OpenSans-CondLight", fontSize: "23px", color: "#f9f3cc", align: "center"});
        label6.setOrigin(.5);
        this.howToPlayContainer.add(label6);

        const label7 = new Phaser.GameObjects.Text(this.scene, -200, 795, gameText.FLOWERS[lan], {fontFamily: "OpenSans-CondLight", fontSize: "23px", color: "#f9f3cc"});
        label7.setOrigin(.5);
        this.howToPlayContainer.add(label7);

        const label8 = new Phaser.GameObjects.Text(this.scene, -label7.x, label7.y, gameText.SEASONS[lan], {fontFamily: "OpenSans-CondLight", fontSize: "23px", color: "#f9f3cc"});
        label8.setOrigin(.5);
        this.howToPlayContainer.add(label8);

        this.closeLayerButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 475 * GameVars.scaleX, 75, "texture_atlas_1", "btn_close_off", "btn_close_on");
        this.closeLayerButton.onDown(this.onClickCloseLayer, this);
        this.closeLayerButton.scaleX = GameVars.scaleX;
        this.add(this.closeLayerButton);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            duration: 550,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    private onClickCloseLayer(): void {

        BoardManager.hideInfo();
    }

    private onClickScore(): void {

        this.scoreSystemTab.setFrame("tab_score_system");
        this.howToPlayTab.setFrame("tab_how_to_play_inactive");

        this.add(this.howToPlayContainer);
        this.add(this.scoreSystemContaiener);

        this.bringToTop(this.closeLayerButton);

        AudioManager.playSound("btn_press");
    }

    private onClickHowToPlay(): void {

        this.scoreSystemTab.setFrame("tab_score_system_inactive");
        this.howToPlayTab.setFrame("tab_how_to_play");

        this.add(this.scoreSystemContaiener);
        this.add(this.howToPlayContainer);

        this.bringToTop(this.closeLayerButton);

        AudioManager.playSound("btn_press");
    }
}
